export { default } from './SearchResultsError'
